(function (app, core, common) {
    'use strict';

    const FIXTURES_MODAL = 'fixtures.fixture-modal';

    const STATUS = {
        UPCOMING: 'U',
        LIVE: 'L',
        FIRST_HALF: 'L1',
        SECOND_HALF: 'L2',
        OVERTIME_FIRST_HALF: 'L3',
        OVERTIME_SECOND_HALF: 'L4',
        HALF_TIME: 'LHT',
        COMPLETE: 'C',
        POSTPONED: 'UP'
    };

    const UI_TIMELINE_EVENTS = [
        'MS', // Phase transition
        'T5', // Try
        'PT5', // Penaly Try
        'PT7', // Penalty Try
        'C2', // Conversion
        'P3', // Penalty Kick
        'D3', // Drop Kick
        'Miss Pen', // Missed Penalty
        'Miss Con', // Missed Conversion
        'Sub On', // Substitution On
        'Sub Off', // Substitition Off
        'IR', // Injury Replacement
        'HIA', // Head Injury Assessment
        'Yellow', // Yellow Card
        'Red', // Red Card
        'LHT', // Half Time
        'LFT', // Full Time
        'L3', // Extra Time Start
        'LB', // Extra Time Half Time
        'LSD', // Extra Time Sudden Death
        'LK' // Kicking Competition
    ];

    app.MatchModal = function (
        matchId,
        fixtureElem,
        events,
        isKnockoutPage = true,
        tabParam = '',
        teamParam = ''
    ) {
        const _self = this;

        _self.fixtureContainer = fixtureElem;
        _self.isKnockOutPage = isKnockoutPage;
        _self.fixtureModal = document.querySelector('.js-fixture-modal');
        _self.loader = document.querySelector('.isLoading');
        _self.lastRenderedEvent = 'L1';
        _self.events = events;
        _self.matchId = matchId;

        if (_self.isKnockOutPage) {
            _self.knockoutTabs = document.querySelector('.js-knockout-tabs');
            _self.knockouts = document.querySelectorAll('.js-knockouts');
        } else {
            _self.fixtureTabs = document.querySelector('.js-fixture-tabs');
            _self.genderTabs = document.querySelector('.js-gender-tabs');
            _self.openFilterSidebar = document.querySelector(
                '.js-open-filter-sidebar'
            );
            _self.fixtureList = document.querySelector('.js-fixture-list');
            _self.viewStandingsCta =
                document.querySelector('.js-view-standings');
            _self.kickOffInfo = document.querySelector('.js-ko-info');
            // _self.cupFinalCta = document.querySelector('.js-cup-final-cta');
            // _self.liveMatchCta = document.querySelector('.js-live-cta');
        }
        _self.fixturesCta = document.querySelector('.js-fixtures-cta');

        if (_self.fixtureModal) {
            _self.getMatchInfo(matchId);
        } else {
            core.style.addClass(_self.loader, 'u-hide');
        }
        return _self.events;
    };

    app.MatchModal.prototype.getMatchInfo = async function (
        matchId,
        tabParam = '',
        teamParam = ''
    ) {
        const _self = this;

        core.style.removeClass(_self.loader, 'u-hide');
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const params = { language: app.language };
        const urls = [
            common.endpoints.rugby.match.summary(matchId, params),
            common.endpoints.rugby.match.timeline(matchId, params)
        ];
        const summary = fetch(urls[0]).then((response) => response.json());
        const timeline = fetch(urls[1]).then((response) => response.json());
        const [summaryRes, timelineRes] = await Promise.all([
            summary,
            timeline
        ]);
        const eventId = summaryRes.match.events[0].id;
        const teamId = summaryRes.match.teams[0].id;
        const teamId2 = summaryRes.match.teams[1].id;
        let mergedCoaches = [];

        if (teamId !== '0') {
            const urlsCoach = [
                common.endpoints.rugby.event.squad(eventId, teamId, params),
                common.endpoints.rugby.event.squad(eventId, teamId2, params)
            ];
            const coach1 = fetch(urlsCoach[0]).then((response) =>
                response.json()
            );
            const coach2 = fetch(urlsCoach[1]).then((response) =>
                response.json()
            );
            const coaches = await Promise.all([coach1, coach2]);
            mergedCoaches = [
                coaches[0].management[0],
                coaches[1].management[0]
            ];
        } else {
            core.style.addClass(_self.loader, 'u-hide');
            return;
        }

        _self.renderMatchInfo(summaryRes, timelineRes, mergedCoaches);
        _self.modalListeners();

        if (tabParam === 'lineup') {
            const tab = document.querySelector('[data-tab="js-lineup"]');
            _self.switchMatchTabs(tab);
        }

        if (teamParam === 'lineup-right') {
            const tab = document.querySelector('[data-tab="js-lineup-right"]');
            _self.switchTeamsTabs(tab);
        }
        core.style.addClass(_self.loader, 'u-hide');
    };

    app.MatchModal.prototype.renderMatchInfo = function (
        summary,
        timeline,
        coaches
    ) {
        const _self = this;

        if (!summary || !timeline || !coaches) {
            core.style.addClass(_self.loader, 'u-hide');
            return;
        }

        if (Object.keys(timeline).length > 0) {
            const filteredTimelineEvents = timeline.timeline.filter((entry) => {
                return UI_TIMELINE_EVENTS.includes(entry.type);
            });

            _self.fixtureModal.innerHTML = '';
            const eventCode = _self.fixtureModal.dataset.event;
            const getHalfTimeScores = common.getHalfTimeScores(
                timeline.timeline,
                summary.match.status
            );
            core.style.removeClass(_self.fixtureModal, 'u-hide');

            if (!_self.isKnockOutPage) {
                core.style.addClass(_self.fixtureList, 'u-hide');
                core.style.addClass(_self.fixtureTabs, 'u-hide');
                core.style.addClass(_self.genderTabs, 'u-hide');
                core.style.addClass(_self.openFilterSidebar, 'u-hide');
                core.style.addClass(_self.viewStandingsCta, 'u-hide');
                core.style.addClass(_self.kickOffInfo, 'u-hide');
            } else {
                core.style.addClass(_self.knockoutTabs, 'u-hide');
                _self.knockouts.forEach((knockoutElem) => {
                    core.style.addClass(knockoutElem, 'temporarily-hidden');
                });
            }
            if (_self.fixturesCta) {
                core.style.addClass(_self.fixturesCta, 'u-hide');
            }

            let sortedTimeline = filteredTimelineEvents;
            if (timeline.match && timeline.match.status === STATUS.COMPLETE) {
                sortedTimeline.timeline = timeline.timeline.sort((a, b) => {
                    if (a.time.secs < b.time.secs) {
                        return -1;
                    }
                    if (a.time.secs > b.time.secs) {
                        return 1;
                    }
                    return 0;
                });
            }
            sortedTimeline =
                sortedTimeline.match && sortedTimeline.timeline
                    ? sortedTimeline
                    : timeline;

            _self.fixtureModal.innerHTML = app.templating.render(
                {
                    sortedTimeline,
                    summary,
                    eventCode,
                    coaches,
                    halfTimeScores: getHalfTimeScores
                },
                FIXTURES_MODAL
            );

            const summaryTeams = summary.teams || [];
            const timelineEvents = sortedTimeline.timeline || [];
            _self.updateRenderedSummaryEvents(summaryTeams, timelineEvents);
            if (timelineEvents.length > 0) {
                _self.updateRenderedTimelineEvents(timelineEvents);
            }

            core.style.addClass(_self.fixtureModal, 'isVisible');
            common.setFixtureCta(_self.fixtureContainer);
            const players = _self.fixtureModal.querySelectorAll('.js-player');
            players.forEach(function (player) {
                const playerId = player.dataset.playerId;
                const image = `//www.world.rugby/default/person-images-site/240/${playerId}.png`;
                _self.checkImages(image, (exists) => {
                    if (!exists) {
                        const placeHolder = player.querySelector(
                            '.player__picture-image'
                        );
                        const playerImage =
                            player.querySelector('.player__image');
                        core.style.addClass(placeHolder, 'no-image');
                        playerImage.style.display = 'none';
                    }
                });
            });

            const halfTime = document.querySelectorAll('.isHalftime');
            if (halfTime.length > 1) {
                halfTime.forEach(function (tape, index) {
                    core.style.addClass(tape, 'u-hide');
                    if (index === 1) {
                        core.style.removeClass(tape, 'u-hide');
                    }
                });
            }
        }
    };

    app.MatchModal.prototype.updateRenderedSummaryEvents = function (
        teams,
        timeline
    ) {
        const _self = this;

        let cards = [];
        let scoring = [];

        if (timeline) {
            timeline.forEach((event) => {
                if (event.type) {
                    const eventIsSub = event.type.substring(0, 3) === 'Sub';
                    if (
                        eventIsSub &&
                        event.timestamp &&
                        event.timestamp.millis
                    ) {
                        _self.events.renderedSubs.push(event.timestamp.millis);
                    }
                }
            });
        }

        if (teams) {
            teams.forEach((team) => {
                if (
                    team.disciplinary &&
                    Object.keys(team.disciplinary).length > 0
                ) {
                    cards = team.disciplinary;
                    if (cards.RC) {
                        cards.RC.forEach((red) => {
                            const millis = red.timestamp.millis || 0;
                            _self.events.renderedCards.push(millis);
                        });
                    }
                    if (cards.YC) {
                        cards.YC.forEach((yellow) => {
                            const millis = yellow.timestamp.millis || 0;
                            _self.events.renderedCards.push(millis);
                        });
                    }
                }

                if (team.scoring && Object.keys(team.scoring).length > 0) {
                    scoring = team.scoring;
                    if (scoring.Con) {
                        scoring.Con.forEach((con) => {
                            const millis = con.timestamp.millis || 0;
                            _self.events.renderedScoring.push(millis);
                        });
                    }
                    if (scoring.Pen) {
                        scoring.Pen.forEach((pen) => {
                            const millis = pen.timestamp.millis || 0;
                            _self.events.renderedScoring.push(millis);
                        });
                    }
                    if (scoring.Try) {
                        scoring.Try.forEach((rugbyTry) => {
                            const millis = rugbyTry.timestamp.millis || 0;
                            _self.events.renderedScoring.push(millis);
                        });
                    }
                    if (scoring.dropGoals) {
                        scoring.dropGoals.forEach((dropGoal) => {
                            const millis = dropGoal.timestamp.millis || 0;
                            _self.events.renderedScoring.push(millis);
                        });
                    }
                }
            });
        }
    };

    app.MatchModal.prototype.updateRenderedTimelineEvents = function (
        timeline
    ) {
        const _self = this;

        if (timeline) {
            timeline.forEach((event) => {
                if (event.timestamp && event.timestamp.millis) {
                    _self.events.renderedEvents.push(event.timestamp.millis);
                }
            });
            _self.lastRenderedEvent = timeline[timeline.length - 1].phase;
        }
    };

    app.MatchModal.prototype.modalListeners = function () {
        const _self = this;
        const closeModal = document.querySelector('.js-modal-close');
        const tabs = document.querySelectorAll('.js-modal-tab');
        const teamTabs = document.querySelectorAll('.js-team-tab');
        const team2 = document.querySelectorAll('.js-lineup-right');

        closeModal.addEventListener('click', () => {
            if (!_self.isKnockOutPage) {
                core.style.removeClass(_self.fixtureList, 'u-hide');
                core.style.removeClass(_self.fixtureTabs, 'u-hide');
                core.style.removeClass(_self.openFilterSidebar, 'u-hide');
                core.style.removeClass(_self.genderTabs, 'u-hide');
                core.style.removeClass(_self.viewStandingsCta, 'u-hide');
                core.style.removeClass(_self.kickOffInfo, 'u-hide');
                common.setFixtureCta(_self.fixtureContainer);

                // if (
                //     _self.fixtureContainer.dataset.completed === 'true' &&
                //     _self.cupFinalCta
                // ) {
                //     core.style.removeClass(_self.cupFinalCta, 'u-hide');
                // }

                // if (
                //     _self.fixtureContainer.dataset.live === 'true' &&
                //     _self.liveMatchCta
                // ) {
                //     core.style.removeClass(_self.liveMatchCta, 'u-hide');
                // }
            } else {
                core.style.removeClass(_self.knockoutTabs, 'u-hide');
                _self.knockouts.forEach((knockoutElem) => {
                    core.style.removeClass(knockoutElem, 'temporarily-hidden');
                });
            }
            if (_self.fixturesCta) {
                core.style.removeClass(_self.fixturesCta, 'u-hide');
            }

            let cleanedUrl = window.location.href.split('matchId')[0];
            cleanedUrl =
                cleanedUrl.slice(-1) === '?'
                    ? cleanedUrl.slice(0, -1)
                    : cleanedUrl;
            window.history.replaceState(null, null, cleanedUrl);
            core.style.removeClass(_self.fixtureModal, 'isVisible');

            //scroll the user back to the match they just closed
            common.fireEvent('scrollToMatch', _self.matchId, document);
        });

        if (tabs.length > 0) {
            tabs.forEach((tab) => {
                tab.addEventListener('click', () => {
                    const updatedUrl = window.location.href.split('tab')[0];
                    var refresh =
                        updatedUrl + `tab=${tab.dataset.tab.slice(3)}`;
                    window.history.pushState({ path: refresh }, '', refresh);
                    _self.switchMatchTabs(tab);
                });
            });
        }

        team2.forEach((team) => {
            core.style.addClass(team, 'isHidden');
        });

        if (teamTabs.length > 0) {
            teamTabs.forEach((tab) => {
                tab.addEventListener('click', () => {
                    const updatedUrl = window.location.href.split('&team')[0];
                    var refresh =
                        updatedUrl + `&team=${tab.dataset.tab.slice(3)}`;
                    window.history.pushState({ path: refresh }, '', refresh);
                    _self.switchTeamsTabs(tab);
                });
            });
        }
    };

    app.MatchModal.prototype.switchMatchTabs = function (selectedTab) {
        const tabs = document.querySelectorAll('.js-modal-tab');
        const timeline = document.querySelector('.js-timeline');
        const lineup = document.querySelector('.js-lineup');

        if (tabs) {
            tabs.forEach((tab) => {
                core.style.removeClass(tab, 'isActive');
            });
        }
        core.style.addClass(selectedTab, 'isActive');

        if (timeline) {
            core.style.addClass(timeline, 'u-hide');
        }

        if (lineup) {
            core.style.addClass(lineup, 'u-hide');
        }

        const tabShow = document.querySelector('.' + selectedTab.dataset.tab);
        if (tabShow) {
            core.style.removeClass(tabShow, 'u-hide');
        }
    };

    app.MatchModal.prototype.switchTeamsTabs = function (tab) {
        const teamTabs = document.querySelectorAll('.js-team-tab');
        const team1 = document.querySelectorAll('.js-lineup-left');
        const team2 = document.querySelectorAll('.js-lineup-right');

        teamTabs.forEach((tab) => {
            core.style.removeClass(tab, 'isActive');
        });
        core.style.addClass(tab, 'isActive');
        team1.forEach((team) => {
            core.style.addClass(team, 'isHidden');
        });
        team2.forEach((team) => {
            core.style.addClass(team, 'isHidden');
        });

        const tabShow = document.querySelectorAll('.' + tab.dataset.tab);

        tabShow.forEach((tab) => {
            core.style.removeClass(tab, 'isHidden');
        });
    };

    app.MatchModal.prototype.checkImages = function (url, callback) {
        const img = new Image();
        img.src = url;
        if (img.complete) {
            callback(true);
        } else {
            img.onload = () => callback(true);
            img.onerror = () => callback(false);
        }
    };
})(PULSE.app, PULSE.core, PULSE.app.common);
